/**
 * Forms module design tokens — from the Engage forms mockup. Indigo /
 * teal palette, Montserrat. The renderer (`features/forms/renderer/`)
 * stays brand-agnostic and reads its colours from CSS custom properties
 * the form's BrandKit sets — these tokens are for the JT *product* UI
 * around the form (sidebar nav, builder shell, settings panels), not
 * for the rendered form itself.
 */

export const FORM_UI_COLORS = {
  indigo: '#1B1F6B',
  indigoSoft: '#3A4150',
  teal: '#3CCF9E',
  tealDark: '#2BAF85',
  ink: '#2A2F3A',
  sub: '#5A6172',
  faint: '#9AA0AC',
  line: '#E7E9F0',
  bg: '#F4F6FB',
  white: '#FFFFFF',
  candidate: '#1B1F6B',
  candidateBg: '#EAEBF6',
  contact: '#2BAF85',
  contactBg: '#E4F6EF',
  warn: '#8A6D1F',
  warnBg: '#FBF3D9',
  warnDot: '#D8A930',
  danger: '#B23B1C',
  dangerBg: '#FCE7E2',
  archived: '#6A7080',
  archivedBg: '#EDEFF4',
} as const;

export const FORM_UI_FONT = "'Montserrat', system-ui, sans-serif";
